export const generateIdOutOfAnchorLink = (anchor) =>
  anchor.substring(anchor.indexOf('#') + 1)
